import { Controller } from "stimulus"

// Toggles the "Your next steps" goal picker dropdown open/closed. Selecting an
// option submits its form (a full PATCH to dashboard_goal_path), so this only
// manages open/close and outside-click/Esc dismissal.
export default class extends Controller {
  static targets = ["trigger", "menu"]

  toggle() {
    this.menuTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.menuTarget.hidden = false
    this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.menuTarget.hidden = true
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  closeOnOutsideClick(event) {
    if (!this.menuTarget.hidden && !this.element.contains(event.target)) this.close()
  }

  closeOnEsc(event) {
    if (event.key === "Escape" && !this.menuTarget.hidden) this.close()
  }
}
